import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Restricts a value to English letters, digits, whitespace and common punctuation.
 *
 * Applied to the Application Title on every grant application form. NHC titles appear in donor
 * reporting and listings, so they are kept to a plain Latin character set - this deliberately
 * rejects accented and non-Latin characters, which is why it is not used on narrative fields.
 */
export function englishOnlyValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null; // Don't validate empty values
    }

    const englishOnlyPattern = /^[a-zA-Z0-9\s.,!?;:'"()\[\]{}\/&@#$%*+=_-]*$/;

    return englishOnlyPattern.test(control.value) ? null : {englishOnly: true};
  };
}
